  <template>
    <div>
      <app-table
          clickable
          deletable
          :data="items"
          highlight-rows-on-hover
          :order="params.order"
          :page-size="params.limit"
          @sort="sortItems"
          @rowClick="goToDetail"
          @deleteRow="deleteItem"
          :loading="pending"
      >
        <template slot="header">
          <app-table-header-item class="field_left">
            <app-input
                :label="translations.search"
                type="search"
                v-model="params.search"
                v-debounce:500="fetchItems.bind(true)"
                full-width
            />
          </app-table-header-item>
        </template>

        <app-table-column first sortable attribute="name" :label="translations.name">
          <template slot-scope="row">
            <strong>
              {{ row.name }}
            </strong>
          </template>
        </app-table-column>
        <app-table-column sortable attribute="type" :label="translations.type">
          <template slot-scope="row">
            {{ enumsMap.get(row.type) }}
          </template>
        </app-table-column>

        <app-table-column sortable sort-name="numberOfChannels" :label="translations.numberOfChannel">
          <template slot-scope="row">
            {{ getChannelsCount(row) }}
          </template>
        </app-table-column>
        <app-table-column sortable sort-name="updated" :label="translations.lastChange">
          <template slot-scope="row">
            <div v-html="formatDate(row._updated)" />
          </template>
        </app-table-column>

        <template slot="footer" v-if="itemsMetadata.totalCount > params.limit">
          <app-table-pagination
            :page="listPage"
            :itemsPerPage="params.limit"
            :totalCount="itemsMetadata.totalCount"
            @pageChanged="tablePageChanged"
          />
        </template>
      </app-table>
    </div>
 </template>

<script>
import { prop, length, compose } from 'ramda'
import appTitleMixin from 'mixins/appTitleMixin'
import getItemsListMixin from 'mixins/getItemsListMixin'
import formatDateMixin from '../mixins/formatDateMixin'
import { mapState } from 'vuex'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'TvStations',
  enumsMap: true,
  preventFetchOnCreated: true,
  detailRouteName: 'tv-station',
  preventSaveParams: true
})

export default {
  name: 'tv-stations-base-detail',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
  props: {
    filterName: {
      type: String,
      default: 'groups'
    },
    title: {
      type: String,
      default: ''
    }
  },
  created() {
    if (this.filterName === 'epgSource') {
      this.params.epgSource = this.$route.params.id
    } else if (this.filterName === 'groups') {
      this.params.groups = this.$route.params.id
    }

    this.fetchItems()
  },
  computed: {
    ...mapState({
      pending: state => state.tvStations.pending.tvStations
    }),
    translations() {
      return {
        search: this.$gettext('Vyhledávání'),
        name: this.$gettext('Název'),
        type: this.$gettext('Typ'),
        numberOfChannel: this.$gettext('Počet kanálů'),
        lastChange: this.$gettext('Poslední změna'),
      }
    },
    groupsDisplayName() {
      return this.stationGroups.reduce((res, v) => {
        res[v._id] = v.name
        return res
      }, {})
    },
    currentTitle() {
      return [
        { name: this.$gettext('Skupiny stanic'), link: { name: 'station-groups' } },
        this.title || this.$gettext('Nová skupina stanic')
      ]
    }
  },
  methods: {
    getChannelsCount: compose(length, prop('tvChannelIds')),
    getDeleteMessage(item) {
      return this.$gettext('Počet navázaných kanálů') + ': ' + this.getChannelsCount(item)
    }
  }
}
</script>
